import axios from "axios";
import Head from "next/head";
import { useState, useEffect } from "react";
import BlogCard from "../components/cards/BlogCard";
import SimpleLoader from "../components/loader/SimpleLoader";
import urlSet, { baseUrl } from "../utils/urls";
import { useRouter } from "next/router";

const Transformations = () => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [coaches, setCoaches] = useState([]);
  const [coach, setCoach] = useState(null);
  const [category, setCategory] = useState(null);

  const router = useRouter();

  const changeHandler = (event) => {
    const target = event.target.name;
    const value = event.target.value;
    switch (target) {
      case "coaches":
        return setCoach(value);
      case "categories":
        return setCategory(value);
      default:
        return;
    }
  };

  const loadEmployees = async () => {
    try {
      const emps = await axios.get(
        baseUrl + "/api/v1/employees/?index=0&limit=100000"
      );
      const tempCoaches = emps.data.filter((emp) => emp.role === "coach");
      setCoaches(tempCoaches);
    } catch (err) {}
  };

  useEffect(() => {
    loadEmployees();
  }, []);

  useEffect(() => {
    const updateStories = async () => {
      try {
        const query = {};
        query["limit"] = 10000;
        query["isStory"] = true;
        query["minimal"] = true;
        if (coach && coach != "All") query["coach"] = coach;
        if (category && category != "All") query["subcategory"] = category;

        let url = urlSet.get_blogApi.url;
        Object.keys(query).map((key, index) => {
          if (index === 0) {
            url = url + "?";
          } else {
            url = url + "&";
          }
          url = url + key + "=" + query[key];
        });

        setLoading(true);
        const res = await axios.get(url);
        setStories(res.data);
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    };

    updateStories();
  }, [coach, category]);

  return (
    <div className="transformationStories">
      <Head>
        <meta
          property="og:image"
          content={
            "https://assets.alanvidyushbaptist.com/optimumwellness_logo.jpg"
          }
        />
        <meta
          name="description"
          content="From fighting obesity to gaining body confidence, these are some seriously inspiring transformation stories you'll want to read. Read countless Optimum Wellness success stories related to PCOS, obesity, fitness, thyroid, and so on."
        />
        <meta name="keywords" content="fitness, health, wellness" />
        <title>Inspiring Transformation Stories</title>
      </Head>

      <h1 className="fo-34 fw-700 text-center mt-5 mb-5 mfo-24">
        INSPIRATIONAL STORIES
      </h1>

      {loading && <SimpleLoader />}

      <div className="row m-0 mb-4 filter_transformations">
        <div className="fo-18 fw-600 mt-auto">Filter By</div>
        <select
          name="coaches"
          id=""
          className="calculatorInput"
          onChange={changeHandler}
        >
          <option value="">All coaches</option>
          {coaches.map((c, index) => {
            return (
              <option value={c.name} key={index}>
                {c.name}
              </option>
            );
          })}
        </select>
        <select
          name="categories"
          className="calculatorInput"
          onChange={changeHandler}
        >
          <option value="All">All Categories</option>
          <option value="Weight Loss">Weight Loss</option>
          <option value="Muscle Gain">Muscle Gain</option>
          <option value="Body Recomposition">Body Recomposition</option>
          <option value="Sports Performance">Sports Performance</option>
          <option value="Fitness Modelling">Fitness Modelling</option>
          <option value="Fitness Myths">Fitness Myths</option>
          <option value="Postpartum">Postpartum</option>
        </select>
      </div>

      {router.query && loading === false && stories.length <= 0 && (
        <div className="fo-26 fw-700 text-center mt-5">
          <p>No blogs to show!</p>
        </div>
      )}
      <div className="row m-0">
        {stories.map((story, index) => {
          if (story.transformation_image) {
            return <BlogCard key={index} blog={story} transformation={true} />;
          }

          return undefined;
        })}
      </div>
    </div>
  );
};

export default Transformations;
